import { environment } from '@environments/environment';
import { InvoiceClaimContent } from '../../app/presentations/invoice-claim-voucher/invoice-claim';

export const invoiceClaimJson: Record<string, InvoiceClaimContent> = {
    success: {
        label: 'Klaim Voucher Berhasil',
        description: 'Permintaan sedang diproses, silakan cek SMS Anda',
        image: 'assets/images/success-claim.png',
        buttonText: 'Kembali ke Beranda',
        helpCenter: {
            text: 'Mengalami masalah terkait transaksi ini? Hubungi',
            linkText: 'Pusat Bantuan',
            helpCenterUrl: `${environment.drupalApi}support`
        }
    },
    failed: {
        label: 'Klaim Voucher Gagal',
        description: 'Silakan coba lagi dalam 5 menit lagi',
        image: 'assets/images/failed-claim.png',
        buttonText: 'Kembali ke Beranda',
        helpCenter: {
            text: 'Mengalami masalah terkait transaksi ini? Hubungi',
            linkText: 'Pusat Bantuan',
            helpCenterUrl: `${environment.drupalApi}support`
        }
    }
};
